// extracted by mini-css-extract-plugin
module.exports = {"logoholder":"NomgaLogo_logoholder__3AwVE","LOGO":"NomgaLogo_LOGO__3a8KW","img":"NomgaLogo_img__2Lxbc","big":"NomgaLogo_big__2GYsq"};